import React, { useEffect, useState } from "react";
import {
    StatsContainer,
    StatsContainerWrapper,
    StatsDesc,
    StatsNumber,
    StatsQuote,
    StatsText,
    StyledStats,
} from "./StatisticsBlock.styles";
import StatisticsChart from "../StatisticsChart/StatisticsChart";
import TopScorer from "../TopScorer/TopScorer";
import { fetchData } from "../../../helpers/fetchData";
import LoadingSpinner from "../../../components/spinners/LoadingSpinner";

const StatisticsBlock = () => {
    const [stats, setStats] = useState({});
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        fetchData("statistics")
            .then((res) => setStats(res))
            .then(() => setIsFetching(false))
            .catch((e) => console.error(e));
    }, []);

    return (
        <StyledStats>
            {isFetching ? (
                <LoadingSpinner />
            ) : (
                <>
                    <StatsContainerWrapper>
                        <StatsContainer>
                            <StatsNumber>{stats.wins ?? 0}</StatsNumber>
                            <StatsDesc color={"#9ec400"}>
                                {"ZWYCIĘSTW"}
                            </StatsDesc>
                            <StatsText>
                                {
                                    "W tylu meczach nasza drużyna okazała się być lepsza od przeciwnika."
                                }
                            </StatsText>
                        </StatsContainer>
                        <StatsContainer>
                            <StatsNumber>{stats.loses ?? 0}</StatsNumber>
                            <StatsDesc color={"#bf0010"}>{"PORAŻEK"}</StatsDesc>
                            <StatsText>
                                {
                                    "W tylu meczach drużyna przeciwnika okazała się być lepsza od nas. Poprawimy to!"
                                }
                            </StatsText>
                        </StatsContainer>
                        <StatsContainer>
                            <StatsNumber>{stats.draws ?? 0}</StatsNumber>
                            <StatsDesc color={"grey"}>{"REMISÓW"}</StatsDesc>
                            <StatsText>
                                {
                                    "W tylu meczach nie udało się niestety wyłonić lepszej drużyny."
                                }
                            </StatsText>
                        </StatsContainer>
                    </StatsContainerWrapper>
                    <StatsQuote>{"CO DAJE ŁĄCZNIE..."}</StatsQuote>
                    <StatsContainerWrapper>
                        <StatsContainer>
                            <StatsNumber>{stats.matches ?? 0}</StatsNumber>
                            <StatsDesc color={"darkblue"}>
                                {"ROZEGRANYCH SPOTKAŃ"}
                            </StatsDesc>
                            <StatsText>
                                {"Tyle spotkań już rozegraliśmy."}
                            </StatsText>
                        </StatsContainer>
                        <StatsContainer>
                            <StatsNumber>{stats.tournaments ?? 0}</StatsNumber>
                            <StatsDesc color={"darkviolet"}>
                                {"ROZEGRANYCH TURNIEJÓW"}
                            </StatsDesc>
                            <StatsText>
                                {
                                    "W tylu turniejach barwy zespołu zespołu były reprezentowane przez naszą kadrę."
                                }
                            </StatsText>
                        </StatsContainer>
                    </StatsContainerWrapper>
                    <StatsQuote>{"CO SKŁADA SIĘ NA..."}</StatsQuote>
                    <StatsContainer>
                        <StatisticsChart data={stats.win_ratio ?? 0} />
                        <StatsDesc>{"WSPÓŁCZYNNIK Z/P"}</StatsDesc>
                        <StatsText>
                            {
                                "Tak wygląda nasz współczynnik zwycięstw do porażek po rozegranych spotkaniach."
                            }
                        </StatsText>
                    </StatsContainer>
                    <StatsQuote>{"A TO WSZYSTKO DZIĘKI..."}</StatsQuote>
                    <StatsContainerWrapper>
                        <StatsContainer>
                            <StatsNumber>{stats.goals ?? 0}</StatsNumber>
                            <StatsDesc color={"orange"}>
                                {"STRZELONYCH BRAMEK"}
                            </StatsDesc>
                            <StatsText>
                                {
                                    "Tyle razy nasi zawodnicy pokonywali bramkarza rywali."
                                }
                            </StatsText>
                        </StatsContainer>
                        <StatsContainer>
                            <TopScorer info={stats.top_scorer} />
                            <StatsDesc color={"gold"}>
                                {"KRÓL STRZELCÓW"}
                            </StatsDesc>
                            <StatsText>
                                {
                                    "Ten zawodnik jest najlepszym strzelcem w historii drużyny."
                                }
                            </StatsText>
                        </StatsContainer>
                    </StatsContainerWrapper>
                    <StatsQuote>
                        {
                            "... ORAZ WSZYSTKIM NASZYM ZAWODNIKOM I KIBICOM! DZIĘKUJEMY!"
                        }
                    </StatsQuote>
                </>
            )}
        </StyledStats>
    );
};

export default StatisticsBlock;
